import type { BacklogMember } from '@ai-meeting/shared'

/** Matches the Members tab in Figma (ten rows before the pager appears). */
export const PROJECT_MEMBERS_PAGE_SIZE = 10

type MemberRoleStrings = {
  projectDetailMemberRoleAdmin: string
  projectDetailMemberRoleMember: string
}

/** Label for the project role column, localised when upstream sends known shapes. */
export function memberRoleLabel(member: BacklogMember, t: MemberRoleStrings): string {
  const role = member.role?.trim()
  if (role) {
    const lower = role.toLowerCase()
    if (lower.includes('admin')) return t.projectDetailMemberRoleAdmin
    if (lower === 'member' || lower.includes('normal') || lower.includes('general')) {
      return t.projectDetailMemberRoleMember
    }
    return role
  }
  if (member.role_type === 1) return t.projectDetailMemberRoleAdmin
  return t.projectDetailMemberRoleMember
}

/** Current reader first so "You" sits at the top of the first page. */
export function sortMembersForDisplay(
  members: BacklogMember[],
  currentBacklogUserId: number | null
): BacklogMember[] {
  if (currentBacklogUserId == null) return members
  return [...members].sort((left, right) => {
    const leftSelf = left.id === currentBacklogUserId ? 0 : 1
    const rightSelf = right.id === currentBacklogUserId ? 0 : 1
    if (leftSelf !== rightSelf) return leftSelf - rightSelf
    return left.name.localeCompare(right.name, undefined, { sensitivity: 'base' })
  })
}
